import styles from './contextCard.module.scss'

export default function ContextCardHeader({ title, medium }) {
  const className = medium ? `${styles.header} ${styles.headerMedium}` : styles.header
  return <div className={className}>{title}</div>
}
